<!-- 代理相关 -->
<template>
	<c-dialog ref="dialog" title="专业代理库" width="900" @resolve="resolve">
		<m-search ref="search" @search="search">
			<c-form ref="form" inline>
				<!-- <c-form-item type="input" label="用户名" name="login_name"></c-form-item> -->
				<c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
				<c-form-item type="input" label="代理昵称" name="nick_name"></c-form-item>
			</c-form>
		</m-search>
			
		<c-table ref="table" height="600">
			<c-table-column
				type="selector"
				:multiple="!!multiple"
			></c-table-column>
			
			<!-- <c-table-column
				label="用户名"
				name="login_name"
			></c-table-column> -->
			
			<c-table-column
				label="代理昵称"
				name="nick_name"
				width="300"
			>
				<template v-slot="{data}">
					<div class="flex-center-cross">
						<c-image :src="data.head_photo" preview size="25" style="margin-right: 10px;"></c-image>
						<span>{{data.nick_name}}</span>
					</div>
				</template>
			</c-table-column>
			
			<c-table-column
				label="代理手机号"
				name="user_manage_mobilephone"
                width="120"
            ></c-table-column>
			
			<c-table-column
				label="代理等级"
				name="user_level_name"
				width="100"
			></c-table-column>

		</c-table>
	</c-dialog>
</template>

<script>
	export default {
		props: {
			multiple: Boolean
		},

        data() {
            return {
                productTypeId: null,
				authenticationStateType:[
					{
					    name:'未实名认证',
					    value:0
					},{
					    name:'已实名认证',
					    value:1
					}
				]
            }
        },

		methods: {
			search(data) {
                data.is_prof_agency = 1; //查询专业代理
                data.product_type_id = this.productTypeId; //关联类目ID
				this.$refs.table.load({
                    url: '/platform_user/list',
					data
				});
			},
			
			open(productTypeId) {
                this.productTypeId = productTypeId;
				this.$refs.form.clear();
				this.$refs.search.search();
				this.$refs.dialog.open();
			},
            close(){
                this.$refs.dialog.close();
            },
			resolve(stop) {
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					stop();
					this.$message({
						text: '请选择代理'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>